export interface CCTMovimientoConsulta {
    fechaInicial: any;
    fechaFinal: any;
    tipoCuenta: string;
    tipoMovimiento: string;
}

export class CCTMovimientoConsulta implements CCTMovimientoConsulta {
    constructor(init: CCTMovimientoConsultaFormValues) {
        Object.assign(this, init);
    }
}

export class CCTMovimientoConsultaFormValues {
    fechaInicial: Date | null = null;
    fechaFinal: Date | null = null;
    tipoCuenta: string = "";
    tipoMovimiento: string = "";

    constructor(CCTMovimientoConsulta?: CCTMovimientoConsultaFormValues) {
        if(CCTMovimientoConsulta){
            this.fechaInicial = CCTMovimientoConsulta.fechaInicial;
            this.fechaFinal = CCTMovimientoConsulta.fechaFinal;
            this.tipoCuenta = CCTMovimientoConsulta.tipoCuenta;
            this.tipoMovimiento = CCTMovimientoConsulta.tipoMovimiento;
        }
    }
}